import { Button, type ButtonProps } from "@mantine/core"
import type { UseFormReturnType } from "@mantine/form"

interface IProps<Data = any> {
  form: UseFormReturnType<Data>
  onSubmit: (values: Data) => Promise<void>
}

export function FormButton<Data>({ form, onSubmit, ...props }: IProps<Data> & ButtonProps) {
  return (
    <Button
      type="submit"
      variant="save"
      {...props}
      disabled={!form.isValid() || !form.isDirty()}
      onClick={
        form.onSubmit(async (values) => {
          await onSubmit(values)
          form.resetDirty()
        }) as any
      }
    />
  )
}
